import { useEffect, useMemo, useRef, useState } from 'react';

export const CHIPS_TIPO = [
  { id: 'poste', nome: 'Poste', simbolo: 'circulo', cor: '#f8fafc' },
  { id: 'trafo', nome: 'Trafo', simbolo: 'triangulo', cor: '#aaff00' },
  { id: 'trecho', nome: 'Trecho', simbolo: 'linha', cor: '#a8a29e' },
  { id: 'chave', nome: 'Chave', simbolo: 'linha', cor: '#0000ff' },
  { id: 'protecao', nome: 'Proteção', simbolo: 'linha', cor: '#aa00ff' },
  { id: 'equipamento', nome: 'Equipamento', simbolo: 'linha', cor: '#ff5500' },
];

export const TIPOS_PADRAO = {
  poste: true,
  trafo: true,
  trecho: true,
  chave: true,
  protecao: true,
  equipamento: true,
};

const NOME_FAMILIA = {
  poste: 'Poste',
  trafo: 'Trafo',
  trecho: 'Trecho',
  chave: 'Chave',
  protecao: 'Proteção',
  equipamento: 'Equipamento',
  rotulo: 'Rótulo',
  sem: 'Sem classificação',
};

const FAMILIA_TIPO = {
  POSTE: 'poste',
  POSTE_CONCRETO: 'poste',
  POSTE_MADEIRA: 'poste',
  SUBESTACAO: 'poste',
  TRAFO_MONOFASICO: 'trafo',
  TRAFO_TRIFASICO: 'trafo',
  TRECHO_TRONCO: 'trecho',
  TRECHO_TRIFASICO: 'trecho',
  TRECHO_BT: 'trecho',
  NA: 'chave',
  PROTECAO: 'protecao',
  EQUIPAMENTO: 'equipamento',
  ROTULO: 'rotulo',
};

const ROTULO_TIPO = {
  TRAFO_MONOFASICO: 'Trafo monofásico',
  TRAFO_TRIFASICO: 'Trafo trifásico',
  POSTE_CONCRETO: 'Poste de concreto',
  POSTE_MADEIRA: 'Poste de madeira',
  POSTE: 'Poste',
  ROTULO: 'Rótulo',
  REGULADOR: 'Regulador',
  SUBESTACAO: 'Subestação',
  PROTECAO: 'Proteção',
  NA: 'Chave NA',
  EQUIPAMENTO: 'Equipamento',
  TRECHO_TRONCO: 'Trecho tronco',
  TRECHO_TRIFASICO: 'Trecho trifásico',
  TRECHO_BT: 'Trecho de baixa tensão',
};

const FAMILIA_ESTILO = {
  poste: 'poste',
  postemadeira: 'poste',
  subestacao: 'poste',
  trafotrif: 'trafo',
  trafomono: 'trafo',
  trifasica: 'trecho',
  tronco: 'trecho',
  bt: 'trecho',
  'equipamento na': 'chave',
  protecao: 'protecao',
  equipamentonf: 'equipamento',
  equipamentona: 'chave',
  nomeposte: 'poste',
  rotulo: 'rotulo',
};

const ROTULO_ESTILO = {
  poste: 'Poste',
  postemadeira: 'Poste de madeira',
  subestacao: 'Subestação',
  trafotrif: 'Trafo trifásico',
  trafomono: 'Trafo monofásico',
  trifasica: 'Trifásica',
  tronco: 'Tronco',
  bt: 'BT',
  'equipamento na': 'Chave NA',
  protecao: 'Proteção',
  equipamentonf: 'Equipamento',
  rotulo: 'Rótulo',
};

const COLECAO_VAZIA = { type: 'FeatureCollection', features: [] };

export function semAcento(valor) {
  return String(valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function corDe(props) {
  return String((props && (props.corResolvida || props.corDetectada)) || '').trim().toLowerCase();
}

function arquivoIcone(props) {
  const url = String((props && (props.iconeUrl || props.iconeUrlResolvida)) || '').split('?')[0].toLowerCase();
  const barra = Math.max(url.lastIndexOf('/'), url.lastIndexOf('\\'));
  return barra >= 0 ? url.slice(barra + 1) : url;
}

// O ícone chega com o nome da URL do Google (triangle, placemark_circle, placemark_square) ou
// com o do PNG que o nosso KMZ embute (trafo-trifasico, poste, subestacao).
function iconeTrafo(arquivo) {
  return arquivo.includes('triangle') || arquivo.includes('trafo');
}

function iconeSubestacao(arquivo) {
  return arquivo.includes('square') || arquivo.includes('subestacao');
}

function iconePoste(arquivo) {
  return arquivo.includes('circle') || /^poste/.test(arquivo);
}

// KML_STYLE da description; sem ele, o id do estilo do placemark (TrafoTrif, Poste, Rótulo…).
function estiloDoPonto(props) {
  return semAcento((props && (props.kmlStyle || props.estiloId)) || '');
}

function prefixoRotulo(nome) {
  return /^(eqnf|eqna|teqnf)\b/i.test(String(nome || '').trim());
}

function tokenRotulo(nome) {
  return String(nome || '').trim().replace(/^(eqnf|eqna|teqnf)\s+/i, '').toLowerCase();
}

function familiaPorSinal(props, geometryType) {
  const linha = geometryType === 'LineString' || geometryType === 'MultiLineString';
  const cor = corDe(props);
  const arquivo = arquivoIcone(props);
  if (!linha) {
    if (arquivo.includes('trafo')) return 'trafo';
    if (arquivo.includes('triangle')) {
      if (cor === '#aaff00' || cor === '#fe9a2e') return 'trafo';
      return '';
    }
    if (iconeSubestacao(arquivo)) return 'poste';
    if (iconePoste(arquivo)) return prefixoRotulo(props.nome) ? 'rotulo' : 'poste';
    return '';
  }
  if (cor === '#0000ff') return 'chave';
  if (cor === '#aa00ff') return 'protecao';
  if (cor === '#ff5500') return 'equipamento';
  if (cor) return 'trecho';
  return '';
}

function familiaDe(props, geometryType) {
  const tipo = String((props && props.tipo) || '').trim().toUpperCase();
  if (tipo === 'REGULADOR') {
    const cor = corDe(props);
    if (cor === '#0000ff') return 'chave';
    if (cor === '#aa00ff') return 'protecao';
    if (cor === '#ff5500') return 'equipamento';
    return 'sem';
  }
  if (FAMILIA_TIPO[tipo]) return FAMILIA_TIPO[tipo];
  if (tipo.startsWith('TRECHO_')) return 'trecho';
  if (tipo.startsWith('TRAFO')) return 'trafo';
  if (tipo.startsWith('POSTE') || tipo === 'SUBESTACAO') return 'poste';
  if (tipo.startsWith('EQUIPAMENTO')) return 'equipamento';
  const estilo = estiloDoPonto(props);
  if (FAMILIA_ESTILO[estilo]) return FAMILIA_ESTILO[estilo];
  return familiaPorSinal(props, geometryType) || 'sem';
}

function rotuloEstilo(bruto) {
  const chave = semAcento(bruto);
  return ROTULO_ESTILO[chave] || String(bruto || '').trim() || 'Grupo';
}

function rotuloTipo(bruto) {
  const chave = String(bruto || '').trim().toUpperCase();
  return ROTULO_TIPO[chave] || String(bruto || '').trim() || 'Grupo';
}

function varianteVisual(props, geometryType) {
  const linha = geometryType === 'LineString' || geometryType === 'MultiLineString';
  const cor = corDe(props);
  const arquivo = arquivoIcone(props);
  if (!linha) {
    if (iconeTrafo(arquivo)) {
      if (arquivo.includes('trifasico') || cor === '#aaff00') return { chave: 'trafo-tri', nome: 'Trafo trifásico' };
      if (arquivo.includes('monofasico') || cor === '#fe9a2e') return { chave: 'trafo-mono', nome: 'Trafo monofásico' };
      return { chave: `triangle:${cor || 'x'}`, nome: 'Trafo' };
    }
    if (iconeSubestacao(arquivo)) return { chave: 'subestacao', nome: 'Subestação' };
    if (iconePoste(arquivo)) {
      if (prefixoRotulo(props && props.nome)) return { chave: 'rotulo', nome: 'Rótulo' };
      if (cor === '#61210b') return { chave: 'poste-madeira', nome: 'Poste de madeira' };
      return { chave: `poste:${cor || 'concreto'}`, nome: 'Poste' };
    }
    return null;
  }
  if (cor === '#0000ff') return { chave: 'chave', nome: 'Chave' };
  if (cor === '#aa00ff') return { chave: 'protecao', nome: 'Proteção' };
  if (cor === '#ff5500') return { chave: 'equipamento', nome: 'Equipamento' };
  if (cor === '#ff00ff') return { chave: 'trecho-tronco', nome: 'Trecho tronco' };
  if (cor) return { chave: `linha:${cor}`, nome: 'Trecho' };
  return null;
}

function grupoNomeado(camada, nome, travado) {
  return { id: `${camada}::vis:${semAcento(nome)}`, nome, travado: Boolean(travado) };
}

function grupoDe(props, familia, comPasta, camada, geometryType) {
  if (comPasta) {
    const pasta = String((props && props.pasta) || '').trim();
    if (!pasta) return { id: `${camada}::raiz`, nome: 'Sem pasta', travado: false };
    return { id: `${camada}::pasta:${pasta}`, nome: pasta.split(' / ').pop(), travado: false };
  }
  if (!familia || familia === 'sem') return grupoNomeado(camada, 'Sem classificação', true);
  const estilo = String((props && props.kmlStyle) || '').trim();
  if (estilo) return grupoNomeado(camada, rotuloEstilo(estilo), false);
  const tipo = String((props && props.tipo) || '').trim();
  if (tipo) return grupoNomeado(camada, rotuloTipo(tipo), false);
  const variante = varianteVisual(props, geometryType);
  if (variante) return grupoNomeado(camada, variante.nome, false);
  return grupoNomeado(camada, NOME_FAMILIA[familia] || familia, false);
}

export function chipsDosGrupos(grupos) {
  const mapa = new Map();
  const visitar = (nos) => {
    (nos || []).forEach((no) => {
      if (!no || no.folha || no.travado) return;
      const temSubpasta = (no.filhos || []).some((filho) => !filho.folha);
      if (temSubpasta) {
        visitar(no.filhos);
        return;
      }
      const chave = semAcento(no.nome);
      const atual = mapa.get(chave) || {
        id: chave,
        nome: no.nome,
        simbolo: no.simbolo,
        cor: no.cor,
        iconeUrl: no.iconeUrl || '',
        grupoIds: [],
      };
      if (!atual.grupoIds.includes(no.id)) atual.grupoIds.push(no.id);
      mapa.set(chave, atual);
    });
  };
  Object.keys(grupos || {}).forEach((chave) => visitar(grupos[chave]));
  return [...mapa.values()].sort((a, b) => a.nome.localeCompare(b.nome, 'pt'));
}

export function anotarColecao(collection, camada) {
  const origem = (collection && collection.features) || [];
  const comPasta = origem.some((feature) => feature.properties && String(feature.properties.pasta || '').trim());
  const preparadas = origem.map((feature, index) => {
    const props = feature.properties || {};
    const geometry = feature.geometry || {};
    const familia = familiaDe(props, geometry.type);
    const grupo = grupoDe(props, familia, comPasta, camada, geometry.type);
    return {
      type: 'Feature',
      geometry: feature.geometry,
      properties: {
        ...props,
        camada,
        familia,
        grupo: grupo.id,
        grupoNome: grupo.nome,
        grupoTravado: grupo.travado,
        fid: `${camada}:${index}`,
        parFamilia: '',
      },
    };
  });
  const porNome = new Map();
  preparadas.forEach((feature) => {
    const familia = feature.properties.familia;
    if (familia !== 'chave' && familia !== 'protecao' && familia !== 'equipamento') return;
    const nome = String(feature.properties.nome || '').trim().toLowerCase();
    if (!nome || porNome.has(nome)) return;
    porNome.set(nome, familia);
  });
  preparadas.forEach((feature) => {
    if (feature.properties.familia !== 'rotulo') return;
    const par = porNome.get(tokenRotulo(feature.properties.nome));
    if (par) feature.properties.parFamilia = par;
  });
  return { type: 'FeatureCollection', features: preparadas };
}

function urlDoIcone(props) {
  return String((props && (props.iconeUrlResolvida || props.iconeUrl)) || '');
}

function aparenciaDe(props) {
  const estilo = estiloDoPonto(props);
  const tipo = String((props && props.tipo) || '').trim().toUpperCase();
  const familia = props && props.familia;
  const cor = corDe(props);
  const arquivo = arquivoIcone(props);
  const iconeUrl = urlDoIcone(props);
  const rotulo = familia === 'rotulo' || estilo === 'rotulo' || tipo === 'ROTULO'
    || (iconePoste(arquivo) && prefixoRotulo(props && props.nome));
  if (iconeTrafo(arquivo) || estilo === 'trafotrif' || estilo === 'trafomono' || tipo.startsWith('TRAFO') || familia === 'trafo') {
    const fill = cor || (estilo === 'trafotrif' || tipo === 'TRAFO_TRIFASICO' ? '#aaff00' : '#fe9a2e');
    return { simbolo: 'triangulo', cor: fill, iconeUrl };
  }
  if (iconeSubestacao(arquivo) || estilo === 'subestacao' || tipo === 'SUBESTACAO') {
    return { simbolo: 'quadrado', cor: cor || '#16a34a', iconeUrl };
  }
  if (rotulo) return { simbolo: 'anel', cor: '#f8fafc', iconeUrl };
  if (iconePoste(arquivo) || estilo === 'poste' || estilo === 'postemadeira' || tipo.startsWith('POSTE') || familia === 'poste') {
    const madeira = estilo === 'postemadeira' || tipo === 'POSTE_MADEIRA' || cor === '#61210b';
    return { simbolo: 'circulo', cor: madeira ? '#61210b' : '#f8fafc', iconeUrl };
  }
  if (estilo === 'protecao' || tipo === 'PROTECAO' || familia === 'protecao') return { simbolo: 'linha', cor: cor || '#aa00ff', iconeUrl: '' };
  if (estilo === 'equipamento na' || tipo === 'NA' || familia === 'chave') return { simbolo: 'linha', cor: cor || '#0000ff', iconeUrl: '' };
  if (estilo === 'equipamentonf' || tipo.startsWith('EQUIPAMENTO') || familia === 'equipamento') return { simbolo: 'linha', cor: cor || '#ff5500', iconeUrl: '' };
  if (familia === 'trecho' || estilo === 'trifasica' || estilo === 'tronco' || estilo === 'bt' || tipo.startsWith('TRECHO')) {
    return { simbolo: 'linha', cor: cor || '#78716c', iconeUrl: '' };
  }
  return { simbolo: 'pino', cor: cor || '#2563eb', iconeUrl };
}

function pintarNo(no, props) {
  if (!no) return null;
  if (!no.simbolo) {
    const aparencia = aparenciaDe(props);
    no.simbolo = aparencia.simbolo;
    no.cor = aparencia.cor;
    no.iconeUrl = aparencia.iconeUrl;
  }
  return no;
}

function folhaDe(feature) {
  const props = feature.properties || {};
  const nome = String(props.nome || '').trim();
  if (!nome) return null;
  const aparencia = aparenciaDe(props);
  return {
    id: props.fid,
    nome,
    simbolo: aparencia.simbolo,
    cor: aparencia.cor,
    iconeUrl: aparencia.iconeUrl,
    fid: props.fid,
    folha: true,
    filhos: [],
  };
}

function ordenarNos(nos) {
  nos.sort((a, b) => a.nome.localeCompare(b.nome, 'pt'));
  nos.forEach((no) => {
    const temSubpasta = (no.filhos || []).some((filho) => !filho.folha && (filho.filhos || []).length);
    if (temSubpasta) no.simbolo = 'pasta';
    if (no.filhos.length) ordenarNos(no.filhos);
  });
  return nos;
}

export function arvoreDeGrupo(collection) {
  const features = (collection && collection.features) || [];
  const porId = new Map();
  const raizes = [];
  const garantir = (id, nome, paiId, travado) => {
    const existente = porId.get(id);
    if (existente) return existente;
    const no = { id, nome, travado: Boolean(travado), filhos: [] };
    porId.set(id, no);
    if (paiId && porId.has(paiId)) porId.get(paiId).filhos.push(no);
    else raizes.push(no);
    return no;
  };
  features.forEach((feature) => {
    const props = feature.properties || {};
    const pasta = String(props.pasta || '').trim();
    const camada = props.camada || '';
    if (pasta && String(props.grupo || '').includes('::pasta:')) {
      const partes = pasta.split(' / ');
      let acc = '';
      partes.forEach((parte) => {
        const anterior = acc;
        acc = acc ? `${acc} / ${parte}` : parte;
        garantir(
          `${camada}::pasta:${acc}`,
          parte,
          anterior ? `${camada}::pasta:${anterior}` : '',
          false,
        );
      });
      const pastaNo = porId.get(`${camada}::pasta:${pasta}`);
      pintarNo(pastaNo, props);
      const folha = folhaDe(feature);
      if (folha) pastaNo.filhos.push(folha);
      return;
    }
    if (!props.grupo) return;
    const grupo = pintarNo(
      garantir(props.grupo, props.grupoNome || 'Grupo', '', Boolean(props.grupoTravado)),
      props,
    );
    const folha = folhaDe(feature);
    if (folha && grupo) grupo.filhos.push(folha);
  });
  return ordenarNos(raizes);
}

export function familiaVisivel(props, tipos) {
  const familia = props && props.familia;
  if (!familia || familia === 'sem') return true;
  if (familia === 'rotulo') {
    if (!props.parFamilia) return true;
    return Boolean(tipos && tipos[props.parFamilia]);
  }
  return Boolean(tipos && tipos[familia]);
}

export function buscarNomes(features, termo, passa) {
  const q = semAcento(termo);
  if (q.length < 3) return [];
  return (features || []).filter((feature) => {
    if (passa && !passa(feature)) return false;
    return semAcento(feature.properties && feature.properties.nome).includes(q);
  });
}

function visitarCoordenadas(coords, visita) {
  if (!Array.isArray(coords)) return;
  if (typeof coords[0] === 'number') {
    visita(coords);
    return;
  }
  coords.forEach((item) => visitarCoordenadas(item, visita));
}

export function destinoDas(features) {
  let minLng = Infinity;
  let minLat = Infinity;
  let maxLng = -Infinity;
  let maxLat = -Infinity;
  (features || []).forEach((feature) => {
    const geometry = feature && feature.geometry;
    if (!geometry) return;
    visitarCoordenadas(geometry.coordinates, ([lng, lat]) => {
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return;
      if (lng < minLng) minLng = lng;
      if (lat < minLat) minLat = lat;
      if (lng > maxLng) maxLng = lng;
      if (lat > maxLat) maxLat = lat;
    });
  });
  if (!Number.isFinite(minLng)) return null;
  return {
    bounds: [[minLng, minLat], [maxLng, maxLat]],
    pontoUnico: minLng === maxLng && minLat === maxLat,
  };
}

export function expressaoConsulta(consulta) {
  if (!consulta) return null;
  if (Array.isArray(consulta.fids)) {
    if (!consulta.fids.length) return ['==', ['get', 'fid'], ''];
    return ['in', ['get', 'fid'], ['literal', consulta.fids]];
  }
  const familias = CHIPS_TIPO.filter((item) => consulta.tipos && consulta.tipos[item.id]).map((item) => item.id);
  const grupos = consulta.gruposAbertos && consulta.gruposAbertos.length ? consulta.gruposAbertos : [''];
  const listaFamilia = familias.length ? familias : [''];
  return ['all',
    ['in', ['get', 'grupo'], ['literal', grupos]],
    ['any',
      ['==', ['get', 'familia'], 'sem'],
      ['==', ['coalesce', ['get', 'familia'], ''], ''],
      ['in', ['get', 'familia'], ['literal', listaFamilia]],
      ['all',
        ['==', ['get', 'familia'], 'rotulo'],
        ['any',
          ['!', ['to-boolean', ['get', 'parFamilia']]],
          ['in', ['get', 'parFamilia'], ['literal', listaFamilia]],
        ],
      ],
    ],
  ];
}

export function filtroComConsulta(base, consulta, ponto, etiquetas) {
  if (!consulta) return base;
  let extra = expressaoConsulta(consulta);
  if (ponto && etiquetas === false) {
    const solto = ['any',
      ['!=', ['get', 'familia'], 'rotulo'],
      ['to-boolean', ['get', 'parFamilia']],
    ];
    extra = extra ? ['all', extra, solto] : solto;
  }
  if (!extra) return base;
  if (!base) return extra;
  return ['all', base, extra];
}

// Pasta com visibility 0 no arquivo, como o Google Earth abriria: desligada. Devolve só os grupos
// que ainda não foram semeados, para não desfazer o que a pessoa mudou no painel. O painel só
// usa isso com fecharPastasOcultas; por padrão tudo abre ligado (ver useKmzConsulta).
export function gruposOcultosIniciais(colecoes, jaSemeados) {
  const novos = [];
  (colecoes || []).forEach((colecao) => {
    ((colecao && colecao.features) || []).forEach((feature) => {
      const props = feature.properties || {};
      if (!props.pastaOculta || !props.grupo || props.grupoTravado) return;
      if (jaSemeados.has(props.grupo) || novos.includes(props.grupo)) return;
      novos.push(props.grupo);
    });
  });
  return novos;
}

function idsDoNo(no) {
  return [no.id].concat((no.filhos || []).flatMap(idsDoNo));
}

// Por padrão toda pasta abre ligada, mesmo a que o KML marca com visibility 0 (os nomes dos
// postes): fechada, a busca por código de poste não acha nada. fecharPastasOcultas devolve o
// estado do arquivo, como no Google Earth.
export function useKmzConsulta(colecoes, resetKey, opcoes) {
  const fecharPastasOcultas = Boolean(opcoes && opcoes.fecharPastasOcultas);
  const recebidas = Array.isArray(colecoes) ? colecoes : [];
  const chaveColecoes = recebidas.map((item) => {
    const total = item.collection && item.collection.features ? item.collection.features.length : 0;
    return `${item.chave}:${item.aberto ? 1 : 0}:${total}`;
  }).join('|');
  const recebidasRef = useRef(recebidas);
  recebidasRef.current = recebidas;
  const lista = useMemo(() => recebidasRef.current, [chaveColecoes]);
  const [fechados, setFechados] = useState({});
  const [tipos, setTipos] = useState(TIPOS_PADRAO);
  const [termo, setTermo] = useState('');
  const [indice, setIndice] = useState(0);
  const [isolado, setIsolado] = useState(false);
  const [camera, setCamera] = useState(null);

  const semeadosRef = useRef(new Set());

  useEffect(() => {
    semeadosRef.current = new Set();
    setFechados({});
    setTipos(TIPOS_PADRAO);
    setTermo('');
    setIndice(0);
    setIsolado(false);
    setCamera(null);
  }, [resetKey]);

  useEffect(() => {
    if (!fecharPastasOcultas) return;
    const novos = gruposOcultosIniciais(lista.map((item) => item.collection), semeadosRef.current);
    if (!novos.length) return;
    novos.forEach((id) => semeadosRef.current.add(id));
    setFechados((atual) => {
      const proximo = { ...atual };
      novos.forEach((id) => {
        proximo[id] = true;
      });
      return proximo;
    });
  }, [lista, fecharPastasOcultas]);

  const grupos = useMemo(() => {
    const mapa = {};
    lista.forEach((item) => {
      mapa[item.chave] = arvoreDeGrupo(item.collection || COLECAO_VAZIA);
    });
    return mapa;
  }, [lista]);

  const feicoes = useMemo(
    () => lista.flatMap((item) => (item.aberto ? ((item.collection && item.collection.features) || []) : [])),
    [lista],
  );

  const passa = (feature) => {
    const props = feature.properties || {};
    if (props.grupo && fechados[props.grupo] && !props.grupoTravado) return false;
    return familiaVisivel(props, tipos);
  };

  const acertos = useMemo(
    () => buscarNomes(feicoes, termo, passa),
    // passa fecha sobre fechados e tipos; feicoes muda com a rede visível
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [feicoes, termo, fechados, tipos],
  );

  const itemAtual = acertos.length ? acertos[Math.min(indice, acertos.length - 1)] : null;
  const itemId = itemAtual ? itemAtual.properties.fid : '';
  const acertosRef = useRef(acertos);
  acertosRef.current = acertos;

  useEffect(() => {
    if (semAcento(termo).length < 3) {
      setIsolado(false);
      return;
    }
    if (!itemId) return;
    const atual = acertosRef.current.find((feature) => feature.properties.fid === itemId);
    const destino = destinoDas(atual ? [atual] : []);
    if (!destino) return;
    setCamera({ ...destino, seq: `b:${termo}:${itemId}` });
  }, [termo, itemId]);

  const gruposAbertos = useMemo(() => {
    const ids = [];
    lista.forEach((item) => {
      ((item.collection && item.collection.features) || []).forEach((feature) => {
        const props = feature.properties || {};
        if (!props.grupo || ids.includes(props.grupo)) return;
        if (props.grupoTravado || !fechados[props.grupo]) ids.push(props.grupo);
      });
    });
    return ids;
  }, [lista, fechados]);

  const consulta = useMemo(() => ({
    gruposAbertos,
    tipos,
    fids: isolado ? acertos.map((feature) => feature.properties.fid) : null,
  }), [gruposAbertos, tipos, isolado, acertos]);

  const estadoBusca = semAcento(termo).length < 3 ? 'curto' : (acertos.length ? 'ok' : 'vazio');

  const alternarGrupo = (ids, abrir) => {
    setFechados((atual) => {
      const proximo = { ...atual };
      ids.forEach((id) => {
        if (abrir) delete proximo[id];
        else proximo[id] = true;
      });
      return proximo;
    });
  };

  const enquadrarGrupo = (no) => {
    const ids = new Set(idsDoNo(no));
    const features = lista.flatMap((item) => (item.collection && item.collection.features) || [])
      .filter((feature) => {
        const props = feature.properties || {};
        if (no.fid) return props.fid === no.fid;
        return ids.has(props.grupo) || ids.has(props.fid);
      });
    const destino = destinoDas(features);
    if (destino) setCamera({ ...destino, seq: `g:${no.id}:${Date.now()}` });
  };

  return {
    consulta,
    camera,
    painel: {
      grupos,
      fechados,
      onToggleGrupo: alternarGrupo,
      onEnquadrarGrupo: enquadrarGrupo,
      termo,
      onTermo: (valor) => {
        setTermo(valor);
        setIndice(0);
      },
      indice: acertos.length ? Math.min(indice, acertos.length - 1) : 0,
      total: acertos.length,
      estadoBusca,
      onPasso: (passo) => {
        if (!acertos.length) return;
        setIndice((atual) => (atual + passo + acertos.length) % acertos.length);
      },
      isolado,
      onIsolar: () => setIsolado(true),
      onMostrarTudo: () => setIsolado(false),
      tipos,
      onToggleTipo: (id) => setTipos((atual) => ({ ...atual, [id]: !atual[id] })),
    },
  };
}
